/**
 * Created by edgar.torosyan on 5/28/17.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DynamicLayoutType } from '../dynamic-layout';
import './popup-sub-form.component.scss';
var PopupSubFormComponent = /** @class */ (function () {
    function PopupSubFormComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dynamicLayoutType = DynamicLayoutType;
        this.form = data.form;
        this.title = data.title;
        this.formId = data.formId;
        this.categoryName = data.categoryName;
        this.formKey = data.formKey;
        this.entity = data.entity;
        this.layoutType = data.layoutType;
        this.actionId = data.actionId;
        this.currentLanguageId = this.form.currentLanguage.getId();
        this.popUpValidations = [];
    }
    PopupSubFormComponent.prototype.close = function () {
        this.dialogRef.close({});
    };
    PopupSubFormComponent.prototype.getPopupTitle = function () {
        if (typeof this.title === 'string') {
            return this.title;
        }
        else {
            return this.title[this.currentLanguageId];
        }
    };
    PopupSubFormComponent = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'popup-sub-form',
            template: require('./popup-sub-form.component.html'),
        }),
        __param(1, Inject(MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [MatDialogRef, Object])
    ], PopupSubFormComponent);
    return PopupSubFormComponent;
}());
export { PopupSubFormComponent };
//# sourceMappingURL=popup-sub-form.component.js.map